import { useEffect } from "react";
import "@/App.css";
import Navbar from "@/components/uth/Navbar";
import Hero from "@/components/uth/Hero";
import WhoWeAre from "@/components/uth/WhoWeAre";
import MeritPlatform from "@/components/uth/MeritPlatform";
import ScaleReach from "@/components/uth/ScaleReach";
import BharatFirst from "@/components/uth/BharatFirst";
import ContentPower from "@/components/uth/ContentPower";
import VedicCulture from "@/components/uth/VedicCulture";
import AudienceProfile from "@/components/uth/AudienceProfile";
import InfraPower from "@/components/uth/InfraPower";
import WhatWeDo from "@/components/uth/WhatWeDo";
import PillChoice from "@/components/uth/PillChoice";
import NetworkStrength from "@/components/uth/NetworkStrength";
import BrandCollaborations from "@/components/uth/BrandCollaborations";
import WhyUth from "@/components/uth/WhyUth";
import FutureOS from "@/components/uth/FutureOS";
import ContactFooter from "@/components/uth/ContactFooter";
import BackgroundFX from "@/components/uth/BackgroundFX";
import TextInteractions from "@/components/uth/TextInteractions";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "U'TH TIMES — India's Biggest Independent Youth Media Brand";
  }, []);

  return (
    <div className="App relative min-h-screen bg-[#05050A] text-white noise" data-testid="uth-app-root">
      <BackgroundFX />
      <TextInteractions />
      <div className="scanlines" />
      <div className="vignette" />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <WhoWeAre />
        <MeritPlatform />
        <ScaleReach />
        <BharatFirst />
        <ContentPower />
        <VedicCulture />
        <AudienceProfile />
        <InfraPower />
        <WhatWeDo />
        <PillChoice />
        <NetworkStrength />
        <BrandCollaborations />
        <WhyUth />
        <FutureOS />
        <ContactFooter />
      </main>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
